import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, tap, map } from "rxjs/operators";
import { Articulo } from "../interfaces/articulo.interface";
import { ControlFacturacion } from "../interfaces/control-facturacion.interface";
import { environment } from "../../environments/environment";
import { tokenRoga } from "./config.service";
import { CotizacionMain } from "../interfaces/main-cotizacion.interface";
import { textMonth } from "../tools/tools";
const BASE_URL = environment.urlServices; 
const fetchPreOrderURL =
  BASE_URL + "/report/consultaJSONCotizacion?folio_cotizacion=";
const videoURL = BASE_URL + "/report/consultaVideo?sku=";
const actionURL = BASE_URL + "/cobranzamovil/setAccionLandingPageCotizacion";
const esquemasArticuloURL = BASE_URL + "/rogacore/consultaEsquemasArticulo";
const buscaArticulosURL = BASE_URL + "/inventory/buscaArticulos";
/* const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
 */
@Injectable({
  providedIn: "root",
})
export class RestService {
  versionApp = "";
  environmentName = "";
  constructor(private http: HttpClient) {
    this.versionApp = environment.version;
    this.environmentName = environment.environmentName;
  }

  originConsulta;
  folio;
  mes: string;

  headersRoga() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "RogaServiceAuth": "Token " + tokenRoga,
      }),
    };
  }

  fetchPreOrder(folio): Observable<any> {
    // console.log("fetchPreOrder: ", fetchPreOrderURL + folio);
    return this.http.get(fetchPreOrderURL + folio, this.headersRoga()).pipe(
      tap((obj: CotizacionMain) => JSON.parse),
      catchError(this.handleError<any>("fetchPreOrder"))
    );
  }

  fetchCostFleteForeign(obj: any): Observable<any> {
    return this.http
      .post(BASE_URL + "/cloud/consultarCostoFleteAproximadoForaneo", obj, this.headersRoga())
      .pipe(
        tap((obj) => JSON.parse),
        catchError(this.handleError<any>("fetchCostFleteForeign"))
      );
  }

  fetchVideo(sku): Observable<any> {
    // console.log('url video: ', videoURL);
    return this.http.get(videoURL + sku, this.headersRoga()).pipe(
      tap((obj) => JSON.parse)
      // catchError(this.handleError<any>('fetchVideo'))
    );
  }

  sendAction(action: any): Observable<any> {
    return this.http
      .post(actionURL, JSON.stringify(action), this.headersRoga())
      .pipe(
        tap((obj) => JSON.parse),
        catchError(this.handleError<any>("sendAction"))
      );
  }

  getConsultaEsquemasArticulo(articulo: Articulo) {
    return this.http
      .post(esquemasArticuloURL, articulo, this.headersRoga())
      .pipe(
        map((resp: ControlFacturacion[]) => resp),
        catchError(this.handleError<any>("getConsultaEsquemasArticulo"))
      );
  }

  buscaArticulo(cedis: number, branch: number, sku: string): Observable<any> {
    const body = {
      cedis,
      branch,
      onlyValid: true,
      filter: "Codigo",
      keywords: sku,
    };
    console.log(`📤 buscaArticulos ${sku} -> POST ${buscaArticulosURL}`, JSON.stringify(body));
    return this.http
      .post(buscaArticulosURL, body, this.headersRoga())
      .pipe(
        tap((resp: any[]) =>
          console.log(
            `📥 buscaArticulos ${sku} <-`,
            JSON.stringify((resp || []).map((a) => ({ sku: a.sku, promocionActiva: a.promocionActiva })))
          )
        ),
        catchError(this.handleError<any>("buscaArticulo"))
      );
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  setMes(date: string): void {
    this.mes = textMonth(date);
  }
}
